/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.AlertsManager {
    'use strict';

    import IAlert = Meevo.Model.IAlert;
    import IAlertCategory = Meevo.Model.IAlertCategory;
    import IAlertSetting = Meevo.Model.IAlertSetting;
    import IsForAllEnum = Meevo.Model.IsForAllEnum;
    import NotificationMethodEnum = Meevo.Model.NotificationMethodEnum;
    import ProactiveAlertTypeEnum = Meevo.Model.ProactiveAlertTypeEnum;


    interface IAddNewAlertController {
        currentStep: number;
        lastTab: number;
        alertCategoryList: Array<IAlertCategory>;
        alertSettingList: Array<IAlertSetting>;
        isEditMode: boolean;

        params: IParams;

        initializeEditMode(): void;
        save(): void;
        showList(): void;
    }

    class AddNewAlertController implements IAddNewAlertController {

        static $inject = [
            '$scope',
            '$rootScope',
            '$state',
            'meevo.plugins.alertsManager.AlertsManagerService',
            'meevo.components.busy.BusyService',
            '$q',
            '$mdSidenav'
        ];

        public currentStep: number = 0;
        public lastTab = 4;
        public alertCategoryList: Array<IAlertCategory> = [];
        public alertSettingList: Array<IAlertSetting> = [];

        public isEditMode: boolean = false;

        public params: IParams = {
            alertCategory: null,
            alertSetting: null,
            triggeredByList: [],
            receivedByList: [],
            triggeredUsersByList: [],
            receivedUsersByList: [],
            notifyVia: {
                sms: false,
                email: false,
                oncePerDay: false
            },
            allUsersAreSelectedTriggeredBy: false,
            allUsersAreSelectedReceivedBy: false,
            toEmployee: false,
            userFilterTriggeredBy: UserFilterEnum.ShowAll,
            userFilterReceivedBy: UserFilterEnum.ShowAll,
            dataForReview: [],
            alertConfigurations: {},
            notificationMethod: null,
            deliveryMethods: [],
            isNoSecurityKeyExists: null
        };

        get editMode(): boolean {
            return this.alertsManagerService.alert && !!this.alertsManagerService.alert.id;
        }


        get isAlertTriggeredBySystemUser() {
            if (!this.params.alertSetting || !this.params.alertSetting.id) return false;

            return [
                ProactiveAlertTypeEnum.QuickbooksHasNotBeenSyncedForAmountOfTime,
                ProactiveAlertTypeEnum.AllOrSpecificServiceBookedViaOnlineBooking,
            ].indexOf(this.params.alertSetting.id) !== -1;
        }

        get notApplicableTriggeredBy() {
            return this.params.alertSetting && this.params.alertSetting.id && this.params.alertSetting.isSystemAlert;
        }

        get alertIsSelected(): boolean {
            return !!this.params.alertCategory && !!this.params.alertSetting && !this.params.isNoSecurityKeyExists;
        }

        constructor(protected $scope: angular.IScope,
                    protected $rootScope: ng.IRootScopeService,
                    protected $state: angular.ui.IState,
                    protected alertsManagerService: IAlertsManagerService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $q: angular.IQService,
                    protected $mdSidenav: any) {
            if (alertsManagerService.alert) {
                this.isEditMode = true;
                this.initializeEditMode();
            }

            if (this.editMode) {
                this.currentStep = 1;
            }

            setTimeout(() => {
                this.showSidebar();
            });

            this.alertsManagerService.getTriggeredByLabels();
        }

        isSelectedRecipients(): boolean {
            if (!this.editMode) {
                if ([ProactiveAlertTypeEnum.AllOrSpecificServiceBookedViaOnlineBooking,
                    ProactiveAlertTypeEnum.RatingIsSubmitted,
                    ProactiveAlertTypeEnum.AppointmentCancelledOnline,
                    ProactiveAlertTypeEnum.AppointmentHasBeenCanceled,
                    ProactiveAlertTypeEnum.DocsAndFormsHaveBeenSubmitted].indexOf(this.params.alertSetting.id) !== -1) {
                    return this.params.toEmployee = true;
                } else {
                    return this.params.toEmployee = false;
                }
            }
        }
        /**
         * Initialize Edit Mode
         */
        initializeEditMode(): void {
            const alert = this.alertsManagerService.alert;

            try {
                const alertJson: { triggeredByAllEmployees?: boolean; } = JSON.parse(alert.alertJSON);
                this.params.triggeredByAllEmployees = alertJson.triggeredByAllEmployees === undefined ? false : alertJson.triggeredByAllEmployees;
            } catch (e) {
            }
            this.params.allUsersAreSelectedTriggeredBy = (alert.isForAll & IsForAllEnum.FromAll) === IsForAllEnum.FromAll;
            this.params.allUsersAreSelectedReceivedBy = (alert.isForAll & IsForAllEnum.ToAll) === IsForAllEnum.ToAll;
            this.params.toEmployee = (alert.isForAll & IsForAllEnum.ToEmployee) === IsForAllEnum.ToEmployee;
            this.params.triggeredByList = alert.triggeredByList.filter(item => item.employeeEntityType || item.isEmployee === true);
            this.params.triggeredUsersByList = alert.triggeredByList.filter(item => !item.employeeEntityType || item.isEmployee === false);
            this.params.receivedByList = alert.receivedByList.filter(item => item.employeeEntityType || item.isEmployee === true);
            this.params.receivedUsersByList = alert.receivedByList.filter(item => !item.employeeEntityType || item.isEmployee === false);
            this.params.notifyVia = {
                email: (alert.notificationMethod & NotificationMethodEnum.Email) === NotificationMethodEnum.Email,
                sms: (alert.notificationMethod & NotificationMethodEnum.Sms) === NotificationMethodEnum.Sms,
                oncePerDay: (alert.notificationMethod & NotificationMethodEnum.OnceDay) === NotificationMethodEnum.OnceDay
            };
        }

        showSidebar() {
            this.$mdSidenav('alertsManagerSidenav').open();
        }

        hideSidebar() {
            this.$mdSidenav('alertsManagerSidenav').close();
        }

        /**
         * Go to the next step
         */
        goToNextStep(): void {
            this.currentStep++;

            if(this.currentStep === 2 && this.notApplicableTriggeredBy) {
                this.currentStep++;
            }
        }

        goBackStep(): void {
            this.currentStep--;

            if (this.currentStep === 2 && this.notApplicableTriggeredBy) {
                this.currentStep--;
            }
        }

        /**
         * Create New Alert
         */
        save(): void {
            const alert: IAlert = {
                alert_SId: this.params.alertSetting.id,
                objectStateEnum: Meevo.Model.ObjectStateEnum.Active,
                receivedByList: this.params.allUsersAreSelectedReceivedBy ? [] : [...this.params.receivedByList, ...this.params.receivedUsersByList],
                triggeredByList: this.params.allUsersAreSelectedTriggeredBy ? [] : [...this.params.triggeredByList, ...this.params.triggeredUsersByList],
                alertJSON: JSON.stringify({
                    alertType: this.params.alertSetting.alertType,
                    ...this.params.alertConfigurations,
                    triggeredByAllEmployees: this.params.triggeredByAllEmployees
                }),
                notificationMethod: this.params.notificationMethod,
                isForAll: this.convertIsForAllToFlag(),
                hasServicingEmployee: this.params.toEmployee
            };

            if (this.isEditMode) {
                const {id, entityVersion} = this.alertsManagerService.alert;

                alert.id = id;
                alert.entityVersion = entityVersion;
            }

            this.busyService.start();
            this.alertsManagerService.usageTrackingLog(Model.NounEnum.AlertManager, Model.VerbEnum.SaveButtonClicked);
            this.alertsManagerService[this.isEditMode ? 'update' : 'addNew'](alert)
                .then(() => {
                    this.showList();
                })
                .finally(() => {
                    this.busyService.stop();
                    this.alertsManagerService.alert = null;
                });
        }

        /**
         * Convert 2 boolean values into bin flag
         */
        convertIsForAllToFlag(): number {
            const from = this.params.allUsersAreSelectedTriggeredBy ? IsForAllEnum.FromAll : IsForAllEnum.FromSpecific;
            const to = this.params.allUsersAreSelectedReceivedBy ? IsForAllEnum.ToAll : IsForAllEnum.ToSpecific;
            const toEmployee = this.params.toEmployee ? IsForAllEnum.ToEmployee : 0;

            return from | to | toEmployee;
        }

        /**
         * Display list of created Alerts
         */
        showList(): void {
            this.alertsManagerService.alert = null;
            this.alertsManagerService.view = ViewEnum.List;
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .controller('meevo.plugins.alertsManager.AddNewAlertController', AddNewAlertController);
}
